import React from 'react';
import PropTypes from 'prop-types';

import {Accordion, AccordionSummary, AccordionDetails} from 'views/components';
import {Stack, Divider, Badge, ListItemIcon, Box} from 'views/components';

import CareviewTypes from './careview_types';

// The badge shows the question's position only. There is no drag handle and no delete.
const CareViewItem = (props) => {
  const [isExpanded, setIsExpanded] = React.useState(true);

  const careviewItem = props.careviewItem;
  const index = props.index;

  const CareviewType = CareviewTypes[careviewItem.type];

  if (!CareviewType) {
    return null;
  }

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={1}
    >
      <Accordion
        elevation={0}
        expanded={isExpanded}
        onChange={(event, isExpanded) => setIsExpanded(isExpanded)}
        sx={{width: 1}}
        disableGutters
      >
        <AccordionSummary
          sx={{
            '&.Mui-focusVisible': {
              backgroundColor: 'inherit',
            },
            '& .MuiAccordionSummary-content': {
              ml: 1,
              textTransform: 'none',
            },
          }}
        >
          <Stack direction='row' spacing={1} alignItems='center' width={1}>
            <ListItemIcon sx={{display: 'flex', justifyContent: 'center'}}>
              <Badge
                badgeContent={index}
                color='primary'
                data-testid='taskBadge'
                aria-label='task-number'
                sx={{
                  '& .MuiBadge-badge': {
                    'fontSize': '16px',
                    'height': '32px',
                    'width': '32px',
                    'borderRadius': '20px',
                    'bgcolor': 'primary',
                  },
                }}
              />
            </ListItemIcon>
            <CareviewType.Title />
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{py: 0, px: {xs: 0, md: 2}}}>
          <Box pt={2} ml={{xs: 1, md: 5}}>
            <CareviewType.Content
              careviewItem={careviewItem}
            />
            <Divider
              sx={{
                pt: 1,
              }}
            />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

CareViewItem.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};
export default React.memo(CareViewItem);
